import {
  BoxFormStyled,
  ErrorMsgsStyled,
  LabelStyled,
  SubmitButtonStyled,
} from '@Usician/styles/Form.styled';
import { Heading1Styled, HintStyled } from '@Usician/styles/Text.styled';

import React from 'react';

import Form from '@hangar31/rc-form';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Cookies from 'universal-cookie';

import { withAuth } from '@Usician/withGraph';
import { withClient } from '@Usician/withGraph';

type FormData = {
  email: string;
  password: string;
  newPasswordConfirm: string;
};

function SignUp({ client }: SignUpPageProps) {
  const router = useRouter();
  return (
    <BoxFormStyled>
      <Form
        onSubmit={async (data: FormData) => {
          const {
            data: { token },
          } = await client.signup(data);
          new Cookies().set('usician-token', token, { path: '/' });
        }}
        onSuccess={() => {
          router.push('/redirect');
        }}
        defaultData={{} as FormData}
      >
        <Heading1Styled>Create New Membership Account</Heading1Styled>
        <div css={{ margin: '0 auto', maxWidth: '45rem', padding: '2rem' }}>
          <LabelStyled>
            <span>Email</span>
            <input required type="email" name="email" />
          </LabelStyled>

          <LabelStyled>
            <span>Set Password</span>
            <input
              id="password"
              name="password"
              type="password"
              pattern="^\S{8,}$"
              onChange={e => {
                const target = e.target as HTMLInputElement;
                target.setCustomValidity(
                  target.validity.patternMismatch
                    ? 'Must have at least 8 characters'
                    : ''
                );
                if (e.target.checkValidity()) {
                  const pwd2 = target?.parentNode?.parentNode?.querySelector(
                    '#password_two'
                  ) as HTMLInputElement;
                  if (pwd2) pwd2.pattern = target.value;
                }
              }}
              required
            />
          </LabelStyled>
          <LabelStyled>
            <span>Confirm Password</span>
            <input
              id="password_two"
              name="newPasswordConfirm"
              type="password"
              pattern="^\S{8,}$"
              onChange={e => {
                const target = e.target as HTMLInputElement;
                target.setCustomValidity(
                  target.validity.patternMismatch
                    ? 'Please enter the same password as above'
                    : ''
                );
              }}
              required
            />
          </LabelStyled>
          <HintStyled>
            * Passwords must contain at least 8 characters and at least one
            number
          </HintStyled>
        </div>
        <ErrorMsgsStyled />
        <Link passHref href="/">
          <a css={{ display: 'inline-block', marginTop: '2rem' }}>
            Already A Member? &raquo;
          </a>
        </Link>
        <SubmitButtonStyled
          lg
          stateCSS={{
            WAITING: {},
          }}
        >
          Next &raquo;
        </SubmitButtonStyled>
      </Form>
    </BoxFormStyled>
  );
}

export type SignUpPageProps = ServerSidePagePropsWithClient<
  typeof getServerSideProps
>;
export const getServerSideProps = withAuth(async () => {
  return {
    props: { layout: 'PUBLIC' },
  };
}, 'REDIRECT');
export default withClient(SignUp);
